/**
 * Shared report status enum used across dailyReport, projectDailyReport, and tippingReport.
 */
export enum RosterDailyReportStatus {
  SUBMITTED = "SUBMITTED",
  DRAFT = "DRAFT",
  VOIDED = "VOIDED",
  RE_SUBMITTED = "RE_SUBMITTED",
  FORCE_SUBMITTED = "FORCE_SUBMITTED",
}
